import React from 'react';

const MenuContext = React.createContext();

export { MenuContext as default };

// It is used in layout/index.js to allow every component to access a common hook: const [menuSelected, setMenu] = useState('/home');
// Used in TopBar to create a context to store whitch menu is currently selected
